<template lang="html">
  <div class="icon-download">
    <img src="../../assets/images/download@2x.png" />
    <a :href="link" target="_blank">
      <p>{{name}}</p>
    </a>
  </div>
</template>

<script>
export default {
  name:"IconDownload",
  props: ['name', 'link']
}
</script>

<style lang="scss" scoped>
  .icon-download{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 40px;
    margin-bottom: 15px;
    img{
      display: block;
      width: 20px;
      margin-right: 10px;
      align-self: flex-start;
    }
    a{
      display: block;
      text-decoration: none;
      @media screen and (max-width: 900px){
        white-space: nowrap;
      }
      p{
        font-size: 14px;
        line-height: 30px;
        text-decoration: underline;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// IconDownload.vue?39d5840d